import React, { useState, useEffect } from 'react';
import './HeroCarousel.css';

const slides = [
  {
    quote: "Mastitis doesn’t knock before entering — it quietly spreads through herds, lowering yields and raising costs. Staying ahead with prevention keeps your milk flowing and your business thriving.",
    image: "/images/hero1.jpg"
  },
  {
    quote: "One infected udder can ripple across your entire operation — reducing productivity, risking herd health, and draining profits. Tackling mastitis early is not just protection, it’s progress.",
    image: "/images/hero2.jpg"
  },
  {
    quote: "From the outside, the cow looks fine — but mastitis works silently, slashing milk output and increasing treatment bills. Smart dairy practices keep invisible threats from turning into visible losses. healthy udder is the heart of a dairy farm — care today ensures production tomorrow.",
    image: "/images/hero3.jpg"
  }
];

const HeroCarousel = () => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
  // Preload all images on mount
  slides.forEach(slide => {
    const img = new Image();
    img.src = slide.image;
  });
}, []);


  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
   <section id="home" className="hero-section">
  <img
    src={slides[index].image}
    alt="Hero Slide"
    className="hero-image"
  />

      <div className="hero-overlay">
        <blockquote className="hero-quote" data-aos="fade-up">
          “{slides[index].quote}”
        </blockquote>
      </div>
    </section>
  );
};

export default HeroCarousel;
